module.exports = __webpack_public_path__ + "media/images/icon-inhouse-design-d510fa1ff88dc29f5e52d32605015ebc.svg";